import { useEffect, useRef, useState } from "react";
import { IMAGE_MANIFEST } from "../lib/image-manifest";
import { usePerformance } from "../lib/performance";

export const ResponsiveImage = ({ src, alt = "", priority = false, sizes = "(min-width: 1280px) 480px, (min-width: 1024px) 40vw, (min-width: 768px) 50vw, 90vw", ...props }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(priority);
  const { lowData } = usePerformance();
  const key = src?.match(/(?:pexels-)?photo-[\w-]+/)?.[0];
  const asset = IMAGE_MANIFEST[key];

  useEffect(() => {
    if (visible) return;
    if (!("IntersectionObserver" in window)) { setVisible(true); return; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: lowData ? "80px" : "240px" });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible, lowData]);

  const fallback = asset ? asset.sources[lowData ? 360 : 640] : src;
  const srcSet = asset && !lowData
    ? Object.entries(asset.sources).map(([width, path]) => `${path} ${width}w`).join(", ")
    : undefined;

  return <img ref={ref} width={asset?.width} height={asset?.height} alt={alt}
    src={visible ? fallback : undefined} srcSet={visible ? srcSet : undefined} sizes={srcSet ? sizes : undefined}
    loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "low"} decoding="async"
    {...props} />;
};